'use es6';

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import H2 from 'UIComponents/elements/headings/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UniversalSidebarPreviewFooter from 'customer-data-sidebar/universal/UniversalSidebarPreviewFooter';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { COMMERCE_PAYMENT_TYPE_ID, MEETING_EVENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalSidebarPanelCardsWrapper = ({
  children,
  label,
  objectTypeId,
  objectId,
  onClose,
  readOnly
}) => {
  const getPanelHeaderText = () => {
    switch (objectTypeId) {
      case COMMERCE_PAYMENT_TYPE_ID:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataSidebar.universalSidebarPanelCardsWrapper.paymentsHeader"
        });
      case MEETING_EVENT_TYPE_ID:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataSidebar.universalSidebarPanelCardsWrapper.meetingsHeader"
        });
      default:
        return label;
    }
  };
  const renderHeader = () => {
    return /*#__PURE__*/_jsx(UIPanelHeader, {
      "data-selenium-test": "preview-panel-header",
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: getPanelHeaderText()
        })
      })
    });
  };
  const renderFooter = () => {
    const saveBarContainerProps = {
      alwaysShowSaveBar: true
    };
    return /*#__PURE__*/_jsx(UniversalSidebarPreviewFooter, Object.assign({
      objectTypeId: objectTypeId,
      objectId: objectId,
      readOnly: readOnly
    }, saveBarContainerProps));
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose,
      "data-selenium-test": "sidebar-preview-panel--close-button"
    }), renderHeader(), /*#__PURE__*/_jsx(UIPanelBody, {
      "data-selenium-test": "preview-panel-body",
      children: children
    }), renderFooter()]
  });
};
UniversalSidebarPanelCardsWrapper.propTypes = {
  children: PropTypes.node,
  label: PropTypes.node.isRequired,
  objectTypeId: PropTypes.string.isRequired,
  objectId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};
export default UniversalSidebarPanelCardsWrapper;